import React from 'react';
import dayjs from 'dayjs';

import { GetAllStatuses } from '@/graphql/contracts/_generated_/getAllStatuses.query';
import { CONTRACT_STATES_COLORS, VARIABLE_TYPE } from '@/config/statuses.config';
import {
  OneEvoMigrationData,
  PausedBiilingData
} from '@/pages/ContractDetails/ContractTitle/ContractTitle.container';
import { DEFAULT_DATE_PATTERN } from '@/config/common.config';
import { ONE_EVO_MIGRATED_MESSAGE } from '@/utils/oneEvoMigration.utils';
import { Pill } from '../../Pill/Pill';

import styles from '../page-header.module.scss';

interface IContractTitleProps {
  status: GetAllStatuses['contractStatuses'][number] | undefined;
  billingType?: string[]
  pausedBillingData?: PausedBiilingData;
  oneEvoMigration?: OneEvoMigrationData;
}

// TODO : remove hardcoded naming when we have enum returned for BillingType

export default function HeaderContractStatus(
  { status, pausedBillingData, billingType, oneEvoMigration }: IContractTitleProps
) {
  const oneEvoMigratedText = oneEvoMigration?.oneEvoMigrated
    ? [
      'MIGRATED TO ONEEVO',
      oneEvoMigration.oneEvoContractNumber,
      oneEvoMigration.oneEvoMigrationDate
        ? dayjs(oneEvoMigration.oneEvoMigrationDate).format(DEFAULT_DATE_PATTERN)
        : null
    ].filter(Boolean).join(' - ')
    : '';

  const getBillingPausedText = () => {
    if (!pausedBillingData?.isPaused) return '';
    
    if (pausedBillingData.isDateConsistent === undefined) {
      return pausedBillingData.pausedBillingDate
        ? `BILLING PAUSED - TILL ${dayjs(pausedBillingData.pausedBillingDate).format(DEFAULT_DATE_PATTERN)}`
        : 'BILLING PAUSED INDEFINITELY';
    }
    
    if (pausedBillingData.isDateConsistent && pausedBillingData.pausedBillingDate) {
      return `BILLING PAUSED - TILL ${dayjs(pausedBillingData.pausedBillingDate).format(DEFAULT_DATE_PATTERN)}`;
    }
    
    return 'BILLING PAUSED';
  };

  const BILLING_PAUSED = getBillingPausedText();

  const color = status && CONTRACT_STATES_COLORS[status.status];
  const varBillingType = billingType?.find(type => type === VARIABLE_TYPE);

  return (
    <>
      {status && (
        <span className={styles['contract-header-status']}>
          <Pill
            name={status.formattedStatus}
            title={status.formattedStatus}
            size="large"
            background={color}
            className={styles['contract-header-pill']}
          >
            {status.formattedStatus}
          </Pill>
        </span>
      )}
      {varBillingType && (
        <span className={styles['contract-header-status']}>
          <Pill
            name='Variable'
            title='Variable'
            size="large"
            background={CONTRACT_STATES_COLORS[VARIABLE_TYPE]}
            className={styles['contract-header-pill']}
          >
            {varBillingType}
          </Pill>
        </span>
      )}
      {

      }

      {oneEvoMigration?.oneEvoMigrated && (
        <span className={styles['contract-header-status']}>
          <Pill
            name={oneEvoMigratedText}
            title={ONE_EVO_MIGRATED_MESSAGE}
            size="large"
            background={CONTRACT_STATES_COLORS.Merged}
            className={styles['contract-header-pill']}
          >
            {oneEvoMigratedText}
          </Pill>
        </span>
      )}

      {pausedBillingData?.isPaused && (
        <span className={styles['contract-header-status']}>
          <Pill name={BILLING_PAUSED}
            title={BILLING_PAUSED}
            size="large"
            background={CONTRACT_STATES_COLORS.Expired}
            className={styles['contract-header-pill']}
          >
            {BILLING_PAUSED}
          </Pill>

        </span>
      )}
    </>
  );


}
